import React, { useEffect, useRef, useState } from 'react';
import { Search, MapPin, Loader2 } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';

export const HeroSection = ({ onSearch, searchFilters, setSearchFilters }) => {
  const videoRef = useRef(null);
  
  // --- FIX 1: GESTIONE INIZIALE "Tutte le città" ---
  // Se il filtro è "Tutte le città", il campo di testo parte vuoto per mostrare il placeholder.
  const [citySearchTerm, setCitySearchTerm] = useState(
    searchFilters.zone === 'Tutte le città' ? '' : (searchFilters.zone || '')
  );
  
  const [cities, setCities] = useState([]); 
  const [filteredCities, setFilteredCities] = useState([]); 
  const [showSuggestions, setShowSuggestions] = useState(false); 
  const [loadingCities, setLoadingCities] = useState(false); 
  const wrapperRef = useRef(null); 

  // 1. CARICAMENTO DATI COMUNI
  useEffect(() => {
    const fetchCities = async () => {
      setLoadingCities(true);
      try {
        const response = await fetch('https://raw.githubusercontent.com/matteocontrini/comuni-json/master/comuni.json');
        const data = await response.json();
        const cityNames = data.map(c => c.nome);
        setCities(cityNames);
      } catch (error) {
        console.error("Errore caricamento comuni:", error);
        setCities(['Roma', 'Milano', 'Napoli', 'Torino', 'Palermo', 'Firenze']);
      } finally {
        setLoadingCities(false);
      }
    };
    fetchCities();
  }, []);

  // 2. FILTRO DINAMICO CITTA'
  useEffect(() => {
    if (citySearchTerm.length > 1) {
      const results = cities.filter(city =>
        city.toLowerCase().startsWith(citySearchTerm.toLowerCase())
      );
      setFilteredCities(results.slice(0, 50)); 
      setShowSuggestions(true);
    } else {
      setFilteredCities([]);
      setShowSuggestions(false);
    }
  }, [citySearchTerm, cities]);

  // 3. CHIUSURA CLICK ESTERNO
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [wrapperRef]);

  // GESTIONE SELEZIONE CITTA'
  const handleSelectCity = (city) => {
    setCitySearchTerm(city); 
    setSearchFilters({ ...searchFilters, zone: city }); 
    setShowSuggestions(false); 
  };

  const handleCityInputChange = (e) => {
    const val = e.target.value;
    setCitySearchTerm(val);
    if (val === '') {
        // Se cancella, reimposta il filtro generico o vuoto
        setSearchFilters({ ...searchFilters, zone: '' });
    }
  };

  return (
    // --- FIX 2: RIMOSSO overflow-hidden DA QUI ---
    // La sezione ora permette al contenuto (il menu) di uscire dai bordi.
    <section id="home" className="relative pt-6" style={{ minHeight: '600px' }}> 
      
      {/* --- BACKGROUND DECORATIVO ISOLATO --- */}
      {/* Questo div gestisce l'overflow delle decorazioni senza tagliare il menu */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10">
         <div className="absolute top-20 right-10 w-64 h-64 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" />
         <div className="absolute top-40 left-10 w-64 h-64 bg-teal-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" />
      </div>

      <div className="container mx-auto px-4 relative z-20"> {/* Aumentato z-index */}
        <div className="max-w-4xl mx-auto text-center">
          
          {/* Logo e Testo */}
          <div className="mb-8 flex justify-center">
            <div className="relative inline-block text-center">
              {/* MODIFICA: Rimossa immagine logo e inserito testo */}
              <div className="text-4xl md:text-5xl font-bold text-gray-800 mb-2">
                VeCo Vetrinaconsulenti.it
              </div>
              <div className="text-4xl font-bold text-center mt-2 text-gray-800">
                TI PREMIA
              </div>
            </div>
          </div>

          <div className="mb-12">
            <p className="text-lg text-gray-600 mt-4 max-w-2xl mx-auto font-medium">
              I vantaggi esclusivi riservati alla community VeCo
            </p>
          </div>

          {/* Search Box */}
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Cerca attività convenzionate
          </h2>
          <p className="text-gray-600 mb-6">
            Esplora le attività partner che offrono sconti esclusivi ai possessori della tessera VeCo
          </p>            
          
          <div className="space-y-4">
            {/* Input Nome Attività */}
            <div className="relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <Input
                type="text"
                placeholder="Cerca per nome attività..."
                value={searchFilters.searchTerm}
                onChange={(e) => setSearchFilters({ ...searchFilters, searchTerm: e.target.value })}
                className="pl-12 h-14 text-lg border-gray-200 focus:border-teal-500 focus:ring-teal-500 bg-white"
              />
            </div>

            {/* Input Città (Autocomplete) */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              
              <div className="relative" ref={wrapperRef}>
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 z-10 pointer-events-none">
                    {loadingCities ? <Loader2 className="w-5 h-5 animate-spin" /> : <MapPin className="w-5 h-5" />}
                </div>
                
                <Input
                  type="text"
                  placeholder="Tutte le città (o scrivi per cercare...)" 
                  value={citySearchTerm}
                  onChange={handleCityInputChange}
                  onFocus={() => citySearchTerm.length > 1 && setShowSuggestions(true)}
                  className="pl-12 h-14 text-lg border-gray-200 focus:border-teal-500 focus:ring-teal-500 bg-white"
                  autoComplete="off"
                />

                {/* Tendina Suggerimenti */}
                {/* Aggiunto z-50 e max-h aumentata per evitare problemi */}
                {showSuggestions && filteredCities.length > 0 && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white text-left text-gray-800 rounded-lg shadow-2xl border border-gray-200 max-h-80 overflow-y-auto z-50">
                    {filteredCities.map((city, index) => (
                      <div 
                        key={index}
                        onClick={() => handleSelectCity(city)}
                        className="px-4 py-3 hover:bg-teal-50 cursor-pointer transition-colors border-b border-gray-50 last:border-0 text-lg"
                      >
                        {city}
                      </div>
                    ))}
                  </div>
                )}
                 
                 {/* Messaggio "Nessuna città" - Mostra solo se l'utente ha scritto qualcosa che non è "Tutte le città" */}
                 {showSuggestions && filteredCities.length === 0 && citySearchTerm.length > 1 && citySearchTerm !== 'Tutte le città' && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white text-left text-gray-500 rounded-lg shadow-xl border border-gray-200 p-4 z-50">
                        Nessuna città trovata con questo nome.
                    </div>
                 )}
              </div>

              <Button
                onClick={onSearch}
                size="lg"
                className="h-14 text-lg font-semibold bg-teal-600 hover:bg-teal-700 transition-colors"
              >
                <Search className="w-5 h-5 mr-2" />
                Cerca
              </Button>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-6 relative z-0">
          <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-gray-100">
            <div className="text-3xl font-bold text-teal-600">12+</div>
            <div className="text-sm text-gray-600 mt-1">Attività Partner</div>
          </div>
          <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-gray-100">
            <div className="text-3xl font-bold text-purple-600">5+</div>
            <div className="text-sm text-gray-600 mt-1">Categorie</div>
          </div>
          <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-gray-100 col-span-2 md:col-span-1">
            <div className="text-3xl font-bold text-green-600">20%</div>
            <div className="text-sm text-gray-600 mt-1">Sconto Medio</div>
          </div>
        </div>
      </div>
    </section>
  );
};